import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=e3b315ea&scoped=true"
import script from "./SkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./SkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=e3b315ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b315ea",
  null
  
)

export default component.exports